module.exports = __webpack_public_path__ + "static/media/win-reward-A03.eae43eac.png";